import React, { useState } from "react";
import { X } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Shared";
import { PageHeader } from "./PaintlessDentRemoval";
import { CtaBanner } from "./Home";
import Seo from "../components/Seo";
import { gallery } from "../mock";

const categories = ["All", ...Array.from(new Set(gallery.map((g) => g.category)))];

const Gallery = () => {
  const [active, setActive] = useState("All");
  const [lightbox, setLightbox] = useState(null);

  const filtered = active === "All" ? gallery : gallery.filter((g) => g.category === active);

  return (
    <div>
      <Seo
        title="Dent Repair Gallery Sydney | Before & After | Dentcraft NSW"
        description="See recent paintless dent removal repairs by Dentcraft NSW across Sydney and Western Sydney \u2014 hail damage, door dings and panel restorations returned to a factory finish."
        path="/repairs-gallery"
      />
      <PageHeader
        title="Dent Repair Gallery Sydney"
        crumb="Repairs Gallery"
        image="https://images.unsplash.com/photo-1568831898760-a1031df598dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHeading
            eyebrow="Our Work"
            title="Recent repairs & restorations"
            subtitle="A look at the panels and vehicles we've brought back to a factory finish."
          />

          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${
                  active === c ? "bg-[#84bd00] text-white" : "bg-[#f2f2f2] text-[#555] hover:bg-[#e6efd4]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((g, i) => (
              <Reveal key={g.title + i} delay={(i % 3) * 100}>
                <button
                  onClick={() => setLightbox(g)}
                  className="group relative w-full h-72 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all block"
                >
                  <img src={g.image} alt={`${g.title} \u2013 ${g.category} paintless dent removal in Sydney`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent opacity-90" />
                  <div className="absolute bottom-0 left-0 p-6 text-left">
                    <span className="inline-block bg-[#84bd00] text-white text-[11px] font-semibold px-3 py-1 rounded-full mb-2">{g.category}</span>
                    <h3 className="font-display font-bold text-white text-lg">{g.title}</h3>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-6" onClick={() => setLightbox(null)}>
          <button className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setLightbox(null)}>
            <X size={32} />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={lightbox.image} alt={lightbox.title} className="w-full max-h-[75vh] object-contain rounded-xl" />
            <div className="mt-4 text-center">
              <span className="inline-block bg-[#84bd00] text-white text-xs font-semibold px-3 py-1 rounded-full mb-2">{lightbox.category}</span>
              <h3 className="font-display font-bold text-white text-xl">{lightbox.title}</h3>
            </div>
          </div>
        </div>
      )}

      <CtaBanner />
    </div>
  );
};

export default Gallery;
